import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
    Container,
    PageTitle
} from "../../../../GuestContainer/UserRegister/UserRegister.styles";
import CONSTANTS from "../../../../../constants/Constants";
import Individual from "./Individual";
import PrivateEntity from "./PrivateEntity";

const Consultant = (props) => {
    const { t } = useTranslation();
    const pageType = {
        1: "INDIVIDUAL",
        4: "PRIVATE ENTITY"
    };
    const { userData, avatar } = props;

    const renderMain = () => {
        return (
            <div>
                <Container>
                    <PageTitle>
                        <p className="page-title-header">{t("general.CONSULTANT")}</p>
                        <p className="page-title-footer">
                            {t(`general.${pageType[userData.propertyType]}`)}
                        </p>
                    </PageTitle>
                    {userData.propertyType === CONSTANTS.USER_PROPERTY_TYPE.INDIVIDUAL && <Individual originalUserData={userData} avatar={avatar} />}
                    {userData.propertyType === CONSTANTS.USER_PROPERTY_TYPE.PRIVATE_ENTITY && <PrivateEntity originalUserData={userData} avatar={avatar} />}
                </Container>
            </div>
        );
    };

    return (renderMain());
};

Consultant.propTypes = {
    userData: PropTypes.object,
    avatar: PropTypes.any
};

export default Consultant;
